export const getAccompaniments = (state) => state.accompaniments
